<!--
 * @Author: your name
 * @Date: 2021-07-20 16:31:19
 * @LastEditTime: 2021-12-17 17:54:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\indexes\edit\index.vue
-->
<template>
  <div>
    <detail />
  </div>
</template>
<script>
import detail from './components/details';
export default {
  name: 'SettingIndexesConfigListEdit',
  components: {
    detail,
  },
};
</script>
